// extracted by mini-css-extract-plugin
export default {"container":"User_container__lAI6V","content":"User_content__JwAha","input":"User_input__WLwvl","button":"User_button__u8Vp3"};